<template>
<div class="lottery">
	<van-nav-bar :title="showtitle" left-text="" @click-left="back()" @click-right="showRight ? showRight = false : showRight = true" left-arrow >
	  <template #right>
	    <span style="color:#fff;font-size: 0.8rem;">{{$t('switch')}}</span>
	  </template>
	</van-nav-bar>

	<!-- 历史记录 -->
	<div class="history" v-if="active" @click.self="active = false">
		<div class="history-content">
			<div class="history-header">
				<h3>{{$t('lishijl')}}</h3>
				<van-icon name="cross" class="close-icon" @click="active = false" />
			</div>
			<div class="history-body">
				<div class="left">
					<p>{{$t('game.expect')}}</p>
					<ul>
						<li v-for="(v,key) in lottery_list" :key="key">{{v.expect}}</li>					
					</ul>
				</div>
				<div class="right">
					<p>{{$t('game.jieguo')}}</p>
					<ul>
						<li class="mak" v-for="(v,key) in lottery_list" :key="key">
							<div class="ball">
								<span :class="'idem' + v.opencode[0]">{{v.opencode[0]}}</span>
								<span :class="'idem' + v.opencode[1]">{{v.opencode[1]}}</span>
								<span :class="'idem' + v.opencode[2]">{{v.opencode[2]}}</span>
							</div>
							<div class="res">
								<span>{{v.opencode[0] + v.opencode[1] + v.opencode[2]}}</span>
								<span>{{getSizeText(v.opencode)}}</span>
								<span>{{getDoubleText(v.opencode)}}</span>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>

	<!-- 顶部信息 -->
	<div class="top">
		<div class="qs">
			<div class="game-info">
				<div class="ico">
					<img :src="showimage" alt="">
				</div>
				<div class="info-text">
					<h1>{{lottery.next_expect}}</h1>
					<span class="countdown">
						<span class="countdown-label">{{$t('game.lefttime')}}:</span>
						<van-count-down :time="time" @finish="check()" />
					</span>
				</div>
			</div>
		</div>
		<!-- 原number区域已移除，保持界面简洁 -->
	</div>

	<!-- 投注区域：一行显示所有选项 -->
	<div class="lottery-content">
		<div class="betting-area">
			<div class="betting-options" id="toBottom">
				<div class="options-grid options-row">
					<div class="option-item" 
						:class="{active: choose[v.type]}" 
						v-for="(v,key) in lottery_peilv_list" 
						:key="key" 
						@click="choosePlay(v.type, v.name)">
						<p>{{$t('game.'+v.name)}}</p>
						<!-- <span class="odds">({{v.proportion}})</span> -->
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- 投注面板 -->
	<div class="betting-panel" v-if="shopping">
	  <div class="panel-content">
	    <div class="amount-and-total">
	      <div class="amount-input">
	        <p>{{$t('quantity')}}</p>
	        <input type="number" v-model.number="money" placeholder="0">
	      </div>
	      <div class="total-info">
	        <p>
	          {{$t('total')}}
	          <span class="highlight">{{formData.length}}</span>
	          {{$t('ticketAmount')}}
	          <span class="highlight">{{formData.length * money}}</span>
	        </p>
	      </div>
	    </div>
	  </div>
	</div>
	
	<!-- 游戏切换弹窗 -->
	<van-popup v-model="showRight" position="right" :style="{ width: '65%', height: '100%' }">
		<div class="game-switch-popup">
			<div class="game-item" @click="toLottery(v.key, v.id)" v-for="(v,key) in game_type_list" :key="key">
				<p>{{v.name}}</p>
			</div>
		</div>
	</van-popup>
	
	<!-- 底部操作栏 -->
	<div class="footer">
		<div class="balance-info">
			<p>
				{{$t('availablePoints')}}
				<span class="balance">{{ userInfo.money }}</span>
			</p>
		</div>
		<button class="confirm-btn" @click="jiesuan">
			{{$t('verify')}}
		</button>
	</div>
</div>
</template>

<script>
var time;

export default {
  data() {
    return {
      showtitle: '彩票游戏',
      showimage: '',
      title: '',
      choose: {
        "大": false, "小": false, "单": false, "双": false,
        "3": false, "4": false, "5": false, "6": false, "7": false, "8": false,
        "9": false, "10": false, "11": false, "12": false, "13": false, "14": false,
        "15": false, "16": false, "17": false, "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      showRight: false,
      game_type_list: [],
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: "未选择",
      gameitem: "",
      formData: [],
      money: 0,
      // 新增的控制变量
      isLoadingPeilv: false,
      isLoadingLotteryList: false,
      refreshTimer: null,
      isPageActive: false,
      retryCount: 0,
      MAX_RETRY: 3
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    
    getSizeText(opencode) {
      const sum = parseInt(opencode[0]) + parseInt(opencode[1]) + parseInt(opencode[2]);
      return sum >= 11 && sum <= 18 ? this.$t('game.da') : this.$t('game.xiao');
    },
    
    getDoubleText(opencode) {
      const sum = parseInt(opencode[0]) + parseInt(opencode[1]) + parseInt(opencode[2]);
      return sum % 2 === 0 ? this.$t('game.shuang') : this.$t('game.dan');
    },
    
    toggleHistory() {
      this.active = !this.active;
    },
    
    updateGameInfo(key, id) {
      const gameInfo = this.game_type_list.find(game => game.key === key && game.id === id);
      if (gameInfo) {
        this.showtitle = gameInfo.name;
        this.showimage = gameInfo.ico || gameInfo.logo_pic;
      }
    },
    
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'});
        return;
      }
      
      if (this.$route.name === 'Lottery') {
        this.updateGameInfo(key, id);
        this.$router.replace({path: '/Lottery', query: {key: key, id: id}});
        // 延迟加载，避免竞态条件
        setTimeout(() => {
          this.getLotteryInfo();
          this.getLotteryList();
        }, 300);
      } else {
        this.$router.push({path: '/Lottery', query: {key: key, id: id}});
      }
      this.showRight = false;
    },
    
    doSub() {
      if (this.money === 0) {
        this.$toast(this.$t('game.plsmoney'));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t('game.plsnum'));
        return false;
      }
      if (this.userInfo.money - (this.money * this.formData.length) < 0) {
        this.$toast(this.$t('game.moneynote'));
        return false;
      }
      
      this.$http({
        method: 'post',
        data: {
          item: this.gameitem,
          money: this.money,
          lid: this.lottery.id,
          mid: this.userInfo.id,
          expect: this.lottery.now_expect
        },
        url: 'game_place_order'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.allClear();
          this.getUserInfo();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
      return true;
    },
    
    allClear() {
      for (let i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]['type']] = false;
      }
      this.formData = [];
      this.money = 0;
      this.shopchoose = "未选中";
      this.gameitem = "";
      this.shopping = false;
    },
    
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t('game.plsnum'));
        return false;
      }
      if (this.money === 0) {
        this.$toast(this.$t('game.plsmoney'));
        return false;
      }
      if (this.userInfo.money - (this.money * this.formData.length) < 0) {
        this.$toast(this.$t('game.moneynote'));
        return false;
      }
      
      // 直接提交订单，不弹出确认对话框
      this.doSub();
    },
    
    clearChooes(type) {
      this.formData = this.formData.filter(item => item.type !== type);
      this.choose[type] = false;
      
      if (this.formData.length >= 1) {
        this.shopchoose = this.formData.map(item => this.$t("game." + item.name)).join(",");
        this.gameitem = this.formData.map(item => item.type).join(",");
      } else {
        this.shopchoose = "未选中";
        this.gameitem = "";
        this.shopping = false;
      }
    },
    
    choosePlay(type, name) {
      if (this.choose[type]) {
        this.choose[type] = false;
        this.formData = this.formData.filter(item => item.type !== type);
      } else {
        this.formData.push({'name': name, 'type': type});
        this.choose[type] = true;
      }
      
      this.shopping = this.formData.length >= 1;
      if (this.formData.length >= 1) {
        this.shopchoose = this.formData.map(item => this.$t("game." + item.name)).join(",");
        this.gameitem = this.formData.map(item => item.type).join(",");
      } else {
        this.shopchoose = "未选中";
        this.gameitem = "";
      }
    },
    
    check() {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'});
        return;
      }
      
      // 清除之前的定时器
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }
      
      // 使用防抖，避免频繁请求
      this.refreshTimer = setTimeout(() => {
        this.getLotteryInfo();
      }, 1000);
    },
    
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('common.refresh'));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    
    getUserInfo() {
      return new Promise((resolve) => {
        this.$http({
          method: 'get',
          url: 'user_info'
        }).then(res => {
          if (res.code === 200) {
            this.userInfo = res.data;
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
          resolve();
        }).catch(() => resolve());
      });
    },
    
    getLotteryPeilv() {
      // 添加请求锁和参数验证
      if (this.isLoadingPeilv) return;
      if (!this.$route.query.id) {
        console.warn('缺少游戏ID参数');
        return;
      }
      
      this.isLoadingPeilv = true;
      
      this.$http({
        method: 'get',
        data: {id: this.$route.query.id},
        url: 'lottery_get_peilv'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
          this.retryCount = 0; // 重置重试计数
          // 缓存成功的数据
          localStorage.setItem('cached_peilv_data', JSON.stringify(res.data));
        } else if (res.code === 401) {
          this.$toast(res.msg);
        } else if (res.code === 500) {
          console.error('服务器内部错误，使用缓存数据');
          this.useCachedPeilvData();
        }
      }).catch(error => {
        console.error('获取赔率失败:', error);
        if (this.retryCount < this.MAX_RETRY) {
          this.retryCount++;
          console.log(`第${this.retryCount}次重试获取赔率...`);
          setTimeout(() => this.getLotteryPeilv(), 1000 * this.retryCount);
        } else {
          this.useCachedPeilvData();
        }
      }).finally(() => {
        this.isLoadingPeilv = false;
      });
    },
    
    // 添加缓存降级方案
    useCachedPeilvData() {
      const cached = localStorage.getItem('cached_peilv_data');
      if (cached) {
        this.lottery_peilv_list = JSON.parse(cached);
        this.$toast('使用缓存数据');
      }
    },
    
    getGameItem() {
      return new Promise((resolve) => {
        this.$http({
          method: 'get',
          url: 'lottery_hot'
        }).then(res => {
          this.game_type_list = res.data;
          if (this.$route.query.key && this.$route.query.id) {
            this.updateGameInfo(this.$route.query.key, this.$route.query.id);
          }
          resolve();
        }).catch(() => resolve());
      });
    },
    
    getLotteryList() {
      // 添加请求锁，防止重复请求
      if (this.isLoadingLotteryList) return;
      if (!this.$route.query.key) {
        console.warn('缺少游戏key参数');
        return;
      }
      
      this.isLoadingLotteryList = true;
      
      this.$http({
        method: 'get',
        data: {key: this.$route.query.key},
        url: 'lottery_get_one_list'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          // 移除这里的 getLotteryPeilv() 调用，避免重复
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      }).finally(() => {
        this.isLoadingLotteryList = false;
      });
    },
    
    getLotteryInfo() {
      if (!this.$route.query.key) {
        console.warn('缺少游戏key参数');
        return;
      }
      
      this.$http({
        method: 'get',
        data: {key: this.$route.query.key},
        url: 'lottery_get_info'
      }).then(res => {
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t('game.lxgly'));
            this.$router.push({path: '/Home'});
            return false;
          }
          this.lottery = res.data;
          this.showimage = res.data.ico;
          this.showtitle = res.data.name;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t('game.kjcc') + this.lottery.now_expect);
          }
          
          this.sum = parseInt(res.data.opencode[0]) + parseInt(res.data.opencode[1]) + parseInt(res.data.opencode[2]);
          
          if (this.sum >= 11 && this.sum <= 18) {
            this.size = this.$t('game.da');
          } else if (this.sum >= 3 && this.sum <= 10) {
            this.size = this.$t('game.xiao');
          }
          
          if (this.sum % 2 === 0) {
            this.double = this.$t('game.shuang');
          } else {
            this.double = this.$t('game.dan');
          }
          
          // 成功获取信息后，再获取赔率数据
          if (!this.isLoadingPeilv) {
            this.getLotteryPeilv();
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    
    // 添加清理资源的方法
    cleanupResources() {
      this.isPageActive = false;
      // 清理所有定时器和请求
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = null;
      }
    }
  },
  
  // 页面生命周期优化
  activated() {
    this.isPageActive = true;
    // 延迟加载，避免与其他页面冲突
    setTimeout(() => {
      this.getLotteryInfo();
      this.getLotteryList();
    }, 500);
  },
  
  deactivated() {
    this.cleanupResources();
  },
  
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'});
    } else {
      // 顺序加载，避免并发请求冲突
      this.getUserInfo().then(() => {
        this.getGameItem().then(() => {
          // 延迟执行，确保参数正确
          setTimeout(() => {
            this.getLotteryInfo();
            this.getLotteryList();
          }, 300);
        });
      });
    }
  },
  
  destroyed() {
    this.cleanupResources();
    clearInterval(time);
  }
};
</script>

<style lang='less' scoped>
/* 基础样式保留 */
.lottery {
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(135deg, #8e44ad 0%,#3498db 100%);
    position: relative;
    font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

/* 导航栏样式 */
.van-nav-bar {
    background: linear-gradient(135deg, #3498db, #8e44ad) !important;
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
}

.van-nav-bar__title {
    color: #fff;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar .van-icon {
    color: #fff;
}

/* 顶部信息区域 */
.top {
    padding: 1.2rem 1rem;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(15px);
    margin: 0.8rem;
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.game-info {
    display: flex;
    align-items: center;
    margin-bottom: 0;
}

.ico {
    width: 4rem;
    height: 4rem;
    border-radius: 16px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.1);
    padding: 0.4rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.ico img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
}

.info-text {
    flex: 1;
    margin-left: 1.2rem;
}

.info-text h1 {
    font-size: 1.4rem;
    color: #fff;
    font-weight: 700;
    margin-bottom: 0.4rem;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.countdown {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    color: #4fc3f7;
}

.countdown-label {
    margin-right: 0.5rem;
}

/* 倒计时时间数字样式 */
.countdown .van-count-down {
    font-size: 1.3rem;
    color: #ffd54f;
    font-weight: bold;
    margin-left: 0.3rem;
    text-shadow: 0 0 10px rgba(255, 213, 79, 0.5);
}

/* 投注区域：一行显示所有选项的关键样式 */
.lottery-content {
    flex: 1;
    padding: 0.8rem;
}

.betting-area {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    margin: 0.5rem;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    overflow-x: auto; /* 水平滚动支持 */
    overflow-y: hidden;
}

.betting-options {
    padding: 0.5rem;
    white-space: nowrap; /* 关键：防止换行 */
}

.options-grid {
    display: flex; /* 改为flex实现一行排列 */
    flex-direction: row;
    gap: 0.8rem;
    padding: 0.5rem;
    flex-wrap: nowrap; /* 强制不换行 */
    justify-content: flex-start;
    align-items: stretch;
}

/* 新增一行显示样式类 */
.options-row {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
}

.option-item {
    flex: 0 0 auto; /* 固定宽度，不伸缩 */
    min-width: 4.5rem;
    background: #fff;
    border: 2px solid #e8e8e8;
    border-radius: 30px; /* 更圆润的胶囊风格 */
    padding: 0.6rem 1.2rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: hidden;
}

.option-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #8e44ad, #3498db);
    transform: scaleX(0);
    transition: transform 0.3s ease;
}

.option-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.option-item.active {
    background: linear-gradient(135deg, #8e44ad, #3498db);
    border-color: #8e44ad;
    color: #fff;
    box-shadow: 0 6px 16px rgba(142, 68, 173, 0.4);
}

.option-item.active::before {
    transform: scaleX(1);
}

.option-item p {
    font-size: 0.9rem;
    font-weight: 600;
    margin: 0;
    color: inherit;
    position: relative;
    z-index: 1;
    white-space: nowrap;
}

/* 投注面板 */
.betting-panel {
  position: fixed;
  bottom: 4.5rem;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 24px 24px 0 0;
  box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  padding: 1.2rem;
}

.panel-content {
  padding: 0;
}

.amount-and-total {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 1rem;
}

.amount-input {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: #f8f9fa;
  padding: 0.8rem 1rem;
  border-radius: 12px;
  flex: 1;
  min-height: 60px;
}

.amount-input p {
  font-size: 0.95rem;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  margin: 0;
}

.amount-input input {
  border: 2px solid #e8e8e8;
  border-radius: 10px;
  padding: 0.7rem 0.8rem;
  font-size: 0.95rem;
  text-align: center;
  width: 6rem;
  background: #fff;
  font-weight: 600;
  transition: all 0.3s ease;
}

.amount-input input:focus {
  border-color: #8e44ad;
  outline: none;
  box-shadow: 0 0 0 3px rgba(142, 68, 173, 0.2);
}

.total-info {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 0.8rem 1rem;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #e8e8e8;
  flex: 1;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.total-info p {
  font-size: 0.9rem;
  color: #333;
  font-weight: 500;
  margin: 0;
  line-height: 1.4;
}

.highlight {
  color: #8e44ad;
  font-weight: 700;
  margin: 0 0.2rem;
}

/* 底部操作栏 */
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.2rem 1.5rem;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    z-index: 1001;
    border-radius: 24px 24px 0 0;
}

.balance-info p {
    font-size: 0.95rem;
    color: #666;
}

.balance {
    color: #8e44ad;
    font-weight: 700;
    margin-left: 0.3rem;
    font-size: 1.1rem;
}

.confirm-btn {
    background: linear-gradient(135deg, #8e44ad, #3498db);
    color: #fff;
    border: none;
    border-radius: 30px;
    padding: 1rem 2.2rem;
    font-size: 1.05rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(142, 68, 173, 0.4);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.confirm-btn::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(rgba(255,255,255,0.1), rgba(255,255,255,0));
    transform: rotate(45deg);
    transition: all 0.5s ease;
}

.confirm-btn:active {
    transform: scale(0.96);
    box-shadow: 0 4px 15px rgba(142, 68, 173, 0.5);
}

/* 历史记录样式保持不变 */
.history {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 2000;
    display: flex;
    align-items: flex-end;
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

.history-content {
    background: #fff;
    border-radius: 24px 24px 0 0;
    width: 100%;
    max-height: 80vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    animation: slideUp 0.3s ease;
}

@keyframes slideUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
}

.history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 1.5rem;
    border-bottom: 1px solid #f0f0f0;
    background: #f8f9fa;
}

.history-header h3 {
    font-size: 1.2rem;
    color: #333;
    font-weight: 700;
    margin: 0;
}

.close-icon {
    font-size: 1.4rem;
    color: #666;
    cursor: pointer;
    padding: 0.4rem;
    border-radius: 50%;
    transition: all 0.3s ease;
}

.close-icon:active {
    background: #e8e8e8;
}

.history-body {
    display: flex;
    flex: 1;
    overflow: hidden;
}

.history-body .left,
.history-body .right {
    flex: 1;
    padding: 1.2rem;
    overflow-y: auto;
}

.history-body .left {
    background: #f8f9fa;
    border-right: 1px solid #e8e8e8;
}

.history-body p {
    font-size: 0.95rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1rem;
    position: sticky;
    top: 0;
    background: inherit;
    padding: 0.5rem 0;
}

.history-body ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.history-body li {
    padding: 1rem 0;
    border-bottom: 1px solid #f0f0f0;
    text-align: center;
    font-size: 0.9rem;
    color: #666;
    transition: background 0.2s ease;
}

.history-body li:active {
    background: #f0f0f0;
}

/* CSS骰子样式 */
.idem1, .idem2, .idem3, .idem4, .idem5, .idem6 {
    width: 2.4rem;
    height: 2.4rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 0.3rem;
    border-radius: 12px;
    font-weight: 800;
    color: white;
    font-size: 1.3rem;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    position: relative;
    overflow: hidden;
}

.idem1::after, .idem2::after, .idem3::after, .idem4::after, .idem5::after, .idem6::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(rgba(255,255,255,0.2), rgba(255,255,255,0));
    transform: rotate(45deg);
}

.idem1 { background: linear-gradient(145deg, #ff6b6b, #ff4757); }
.idem2 { background: linear-gradient(145deg, #ff9ff3, #f368e0); }
.idem3 { background: linear-gradient(145deg, #54a0ff, #2e86de); }
.idem4 { background: linear-gradient(145deg, #1dd1a1, #10ac84); }
.idem5 { background: linear-gradient(145deg, #feca57, #ff9ff3); }
.idem6 { background: linear-gradient(145deg, #5f27cd, #341f97); }

/* 游戏切换弹窗 */
.game-switch-popup {
    padding: 1.5rem;
    background: #f8f9fa;
    height: 100%;
    overflow-y: auto;
}

.game-item {
    background: #fff;
    border-radius: 16px;
    padding: 1.4rem;
    margin-bottom: 1rem;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid transparent;
}

.game-item:active {
    background: #f0f0f0;
    transform: scale(0.98);
}

.game-item p {
    font-size: 1.05rem;
    font-weight: 600;
    color: #333;
    margin: 0;
}

/* 滚动条美化 (针对一行选项区域) */
.options-row::-webkit-scrollbar {
    height: 4px;
}
.options-row::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 2px;
}
.options-row::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #8e44ad, #3498db);
    border-radius: 2px;
}

/* 响应式调整 */
@media (max-width: 375px) {
    .option-item {
        min-width: 3.8rem;
        padding: 0.5rem 1rem;
    }
    .option-item p {
        font-size: 0.8rem;
    }
    .footer {
        padding: 1rem 1.2rem;
    }
    .confirm-btn {
        padding: 0.9rem 1.8rem;
        font-size: 1rem;
    }
    .idem1, .idem2, .idem3, .idem4, .idem5, .idem6 {
        width: 2rem;
        height: 2rem;
        font-size: 1.1rem;
        margin: 0 0.2rem;
    }
    
    .top {
        margin: 0.5rem;
        padding: 1rem 0.8rem;
    }
    
    .game-info {
        margin-bottom: 1rem;
    }
    
    .ico {
        width: 3.5rem;
        height: 3.5rem;
    }
    
    .info-text h1 {
        font-size: 1.2rem;
    }
}
</style>